module.exports = __webpack_public_path__ + "static/media/Garbodor_gaussian2.ddd4366e.png";